import React from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { message, Layout as AntLayout } from 'antd';

import withAuthentication from 'hoc/authentication';
import ScrollToTop from 'components/ScrollToTop/ScrollToTop';
import CookieNotice from 'components/CookieNotice';
import Header from 'components/Layout/Header/Header';
import Footer from 'components/Layout/Footer/Footer';
import styles from 'components/Layout/Layout.module.scss';

import './Layout.scss';

class Layout extends React.Component {
  componentDidUpdate (prevProps) {
    if (prevProps.error !== this.props.error) {
      message.destroy();
      message.error(this.props.error.message);
    }
  }

  render () {
    const { children, hideHeader, hideFooter, fullscreen } = this.props;

    return (
      <div className={this.props.className}>
        <ScrollToTop />
        <CookieNotice />

        <AntLayout className={styles.layout}>
          {!hideHeader && <Header {...this.props} />}
          <AntLayout.Content>
            <main className={classnames({
              wrapper: !fullscreen,
              [styles.main]: !fullscreen,
            })}
            >
              {children}
            </main>
          </AntLayout.Content>
          {!hideFooter && <Footer />}
        </AntLayout>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  error: state.error,
});

export default connect(mapStateToProps, null)(withAuthentication(Layout));



// WEBPACK FOOTER //
// ./src/components/Layout/Layout.js